import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Icon from '@scentregroup/ui/components/icon';
import Article from '../../article';
import ResponsiveImage from '../../responsive-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Store = _ref => {
  let {
    store,
    selectStore,
    deselectStore,
    dataTestId
  } = _ref;
  const containerProps = selectStore === null ? {} : {
    onClick: selectStore
  };
  const articleProps = selectStore === null ? {
    link: store.link
  } : {
    onClick: selectStore
  };
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: style.Store
  }, containerProps), {}, {
    "data-id": "store_index_Store_div",
    children: [/*#__PURE__*/_jsx("div", {
      className: style.visual,
      "data-id": "store_index_Store_div_div_1",
      children: /*#__PURE__*/_jsx(ResponsiveImage, {
        className: style.logo,
        desktopImageUrl: store.logo.src,
        mobileImageUrl: store.logo.src,
        alt: store.title,
        desktopRatio: "square",
        mobileRatio: "square",
        numberOfItems: 2,
        bgSize: "contain",
        lazyLoad: false,
        "data-id": "store_index_Store_div_ResponsiveImage"
      })
    }), /*#__PURE__*/_jsx(Article, _objectSpread(_objectSpread({
      heading: store.title,
      headingType: "small",
      location: store.landmarkDescription,
      hoursText: store.hoursText,
      className: style.article,
      dataTestId: dataTestId
    }, articleProps), {}, {
      "data-id": "store_index_Store_div_Article"
    })), deselectStore && /*#__PURE__*/_jsx("button", {
      className: style.exitBtn,
      onClick: deselectStore,
      "data-id": "store_index_Store_button",
      children: /*#__PURE__*/_jsx("div", {
        className: "index-story__iconList___2v9CA typography__bodyFont\u2026",
        "data-id": "store_index_Store_button_div",
        children: /*#__PURE__*/_jsx("div", {
          className: "index-story__icon___25T-B",
          "data-id": "store_index_Store_div_div_6",
          children: /*#__PURE__*/_jsx(Icon, {
            size: "small",
            type: "clear",
            className: "index-story__iconsmall___3ptCo",
            "data-id": "store_index_Store_div_Icon"
          })
        })
      })
    })]
  }));
};
Store.defaultProps = {
  selectStore: null,
  deselectStore: null
};
export default Store;